import FlyingMoney from "../assets/images/money-with-wings.png";
import LightBulb from "../assets/images/light-bulb.png";
import Person from "../assets/images/man-shrugging.png";

const FounderData = [
  {
    id: 0,
    value: "OWNER",
    longValue: "I'm a business owner, startup founder, or consultant",
    backendValue: false,
    hasImage: true,
    image: FlyingMoney,
    hasOptions: false,
  },
  {
    id: 1,
    value: "STARTING",
    longValue: "I want to start a business but haven't started yet",
    backendValue: false,
    hasImage: true,
    image: LightBulb,
    hasOptions: false,
  },
  {
    id: 2,
    value: "OTHER",
    longValue: "I'm not a business owner or founder",
    hasImage: true,
    image: Person,
    hasOptions: false,
  },
];

export default FounderData;
